import React from "react";
import Popup from "../../common/popup";
import FormInput from "../Forms/Input";
import { connect } from "react-redux";
import { fetchCountriesRequest } from "../../Containers/Login/actions";
import { saveCountryAction } from "../../Containers/EmailValidation/actions";

const mapStateToProps = (state) => ({
  countriesList: state.countries.countries,
});

class CountryFormPopup extends React.Component {
  state = {country: ''}

  constructor() {
    super();
    this.onCountryChange = this.onCountryChange.bind(this);
    this.onSaveCountry = this.onSaveCountry.bind(this);
    this.redDisabledCursor = "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"><circle cx=\"8\" cy=\"8\" r=\"7\" fill=\"none\" stroke=\"red\" stroke-width=\"2\"/><line x1=\"4\" y1=\"4\" x2=\"12\" y2=\"12\" stroke=\"red\" stroke-width=\"2\"/></svg>'), not-allowed";
  }


  componentDidMount() {
    this.props.dispatch(fetchCountriesRequest());
  }

    /**
   * 
   * @param {Event} event 
   */
    onCountryChange(event) {
      const value = event.target.value;
      this.setState({country: value})
    }


    onSaveCountry() {
      if(!this.state.country) {
        // show error popup
        return;
      }

      this.props.dispatch(saveCountryAction(this.state.country));
    }
  

  render() {
    return (
      <Popup style={{ height: 250, width: "38%" }} closePopup={this.closePopup}>
        <div style={{ padding: "10px 25px" }}>
         
          <div>
            <p style={{ paddingTop: 8 }}>
              Please Select your country
            </p>
            <FormInput
              type="select"
              placeholder="Country *"
              styles={{ marginBottom: 20, width: "100%" }}
              onChange={this.onCountryChange}
              value={this.state.country}
              name="country"
              options={[
                { value: "", label: "Select Country *" },
                ...this.props.countriesList,
              ]}
            />
            <div className="">
              <button
                className="btn btn-primary"
                style={{ 
                  marginRight: 10,
                  width: "100%",
                  background: "rgb(39, 39, 89)",
                  cursor: !this.state.country ? this.redDisabledCursor : "pointer"
                }}
                disabled={!this.state.country}
                onClick={this.onSaveCountry}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </Popup>
    );
  }
}

export default connect(mapStateToProps)(CountryFormPopup);



// WEBPACK FOOTER //
// ./src/components/Login/CountryFormPopup.js